export const SET_TOS_PAGE = 'SET_TOS_PAGE';
export const SET_LEGAL_PAGES = 'SET_LEGAL_PAGES';
export const TERMS_ACCEPTED = 'TERMS_ACCEPTED';



// WEBPACK FOOTER //
// ./app/actions/legal.js